import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
export const modalCloseButtonStyles = css `
  ${ButtonReset}

  position: absolute;
  top: 8px;
  right: 24px;
  display: grid;
  color: var(--fgColor);
  height: 3rem;
  place-content: center;
  place-items: center;
  width: 3rem;
  z-index: 1;
  pointer-events: all;

  [data-site='ess'] & {
    --fgColor: ${brand.ess.secondary.midGrey};
  }

  [data-site='mep'] & {
    --fgColor: ${brand.ess.secondary.midGrey};
  }

  svg {
    display: block;
    height: ${fluid(16, 22)};
    width: ${fluid(16, 22)};
  }

  &.focus-ring {
    outline: auto;
  }

  @media ${from(Device.Tablet)} {
    right: 13.5vw;
  }

  @media ${from(Device.Desktop)} {
    right: 26vw;
  }
`;
export const Button = styled.button `
  ${modalCloseButtonStyles};
`;
const CloseStyles = {
    Button,
};
export default CloseStyles;
